import {
  BUSCAR_MAPA_ITINERARIO_IDA,
  LIMPAR_MAPA_ITINERARIO_IDA,
  SELECIONAR_ASSENTO_ITINERARIO_IDA,
  BLOQUEAR_POLTRONA_JA_MARCADO_ITINERARIO_IDA
} from '../../actions/types'

const initialState = undefined
const itemInicial = {}

export default function reducerMapaVeiculoItinerarioIda(state = itemInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_MAPA_ITINERARIO_IDA: {
      return action.payload.data;
    }

    case SELECIONAR_ASSENTO_ITINERARIO_IDA: {
      const { assento, fileira } = action.payload;
      const indiceFileira = state.indexOf(state.filter(f => f.id === fileira.id)[0]);
      const novo = [...state];
      const novaFileira = Object.assign({}, fileira);
      const novosAssentos = [...novaFileira.assentos]
      const indiceAssento = novaFileira.assentos.indexOf(assento);
      const novoAssento = Object.assign({}, assento, { selecionado: !assento.selecionado });
      novosAssentos[indiceAssento] = novoAssento;
      novaFileira.assentos = novosAssentos;
      novo[indiceFileira] = novaFileira;

      return novo
    }

    case BLOQUEAR_POLTRONA_JA_MARCADO_ITINERARIO_IDA: {
      const { assento, fileira } = action.payload;
      const indiceFileira = state.indexOf(state.filter(f => f.id === fileira.id)[0]);
      const novo = [...state];
      const novaFileira = Object.assign({}, fileira);
      const novosAssentos = [...novaFileira.assentos]
      const indiceAssento = novaFileira.assentos.indexOf(assento);
      const novoAssento = Object.assign({}, assento, { selecionado: true, ehBloqueado: true });
      novosAssentos[indiceAssento] = novoAssento;
      novaFileira.assentos = novosAssentos;
      novo[indiceFileira] = novaFileira;

      return novo
    }
    case LIMPAR_MAPA_ITINERARIO_IDA: {
      return itemInicial
    }

    default: {
      return state
    }
  }
}
